module.exports = __webpack_public_path__ + "static/redboost-02af3bfb60d33f8213e8f99ffeab6407.jpeg";